// Ручная разметка CTA для Meta Pixel.
//
// Базовый код пикселя (init + PageView) лежит в public/index.html — здесь
// только клики по order-CTA. До этого клики уезжали в Meta автособытием
// SubscribedButtonClick: auto-config подписывается на клик по любой
// кнопке, но стандартным событием его не считает, поэтому лидов в отчётах
// по ним не было. Теперь Lead шлём сами и ни от какой привязки в Events
// Manager не зависим.
//
// Lead шлют кнопки перехода к менеджеру в Telegram. На ask туда ведут все
// order-CTA (модалки выбора канала здесь нет), поэтому размечены все шесть
// живых. Седьмая, anno_promo, размечена про запас — промо-плашка в шапке
// сейчас в JSX-комментарии, и в сборку не попадает.

type Fbq = (...args: unknown[]) => void;

declare global {
  interface Window {
    fbq?: Fbq;
  }
}

/**
 * Стандартное событие Lead по клику на CTA. Шлётся на каждый клик, без
 * схлопывания: ограничитель «один лид на визит» тут стоял, но из-за него
 * при ручной проверке событие уходило только с первого клика, а дальше
 * кнопка молчала — выглядело как сломанный трекинг.
 *
 * @param source  какая кнопка нажата — уезжает в content_name, по нему в
 *                Events Manager видно разбивку по кнопкам.
 */
export function trackLead(source: string): void {
  try {
    // Видно в консоли — быстрый способ проверить срабатывание, не
    // открывая Events Manager. fbq может не быть: блокировщик рекламы,
    // оффлайн, скрипт не успел загрузиться.
    console.log('[pixel] Lead', source, { fbqReady: typeof window.fbq === 'function' });
    window.fbq?.('track', 'Lead', { content_name: source });
  } catch (e) {
    // Трекинг не должен ронять клик по кнопке.
    console.warn('[pixel] Lead failed', e);
  }
}
